/* Dekozen slideshow portu (Athora -> Concept) — bagimsiz vanilla JS, onek: dkzs- */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FP_INTERVAL = 3000;

  function DkzsController(host) {
    this.host = host;
    this.track = host.querySelector('.dkzs-track');
    this.slides = Array.prototype.slice.call(host.querySelectorAll('.dkzs-track > .dkzs-slide'));
    this.dots = Array.prototype.slice.call(host.querySelectorAll('[data-dkzs-dot]'));
    this.mode = host.getAttribute('data-transition') === 'slide' ? 'slide' : 'fade';
    this.autoplayMs = parseInt(host.getAttribute('data-autoplay'), 10) || 0;
    if (REDUCED) this.autoplayMs = 0;
    this.pauseHover = host.hasAttribute('data-pause-hover');
    this.index = 0;
    this.timer = null;
    this.userPaused = false;
    this.inView = true;
    this.fpTimers = [];

    this.bind();
    this.applyFocusability();
    this.setPlayVar();
    if (this.autoplayMs) {
      this.host.classList.add('is-playing');
      this.schedule();
    }
    this.startFp();
  }

  DkzsController.prototype.bind = function () {
    var self = this;
    var prev = this.host.querySelector('[data-dkzs-prev]');
    var next = this.host.querySelector('[data-dkzs-next]');
    var toggle = this.host.querySelector('[data-dkzs-toggle]');
    if (prev) prev.addEventListener('click', function () { self.go(self.index - 1, true); });
    if (next) next.addEventListener('click', function () { self.go(self.index + 1, true); });
    if (toggle) {
      toggle.addEventListener('click', function () {
        self.userPaused = !self.userPaused;
        self.host.classList.toggle('is-playing', !self.userPaused && !!self.autoplayMs);
        self.setPlayVar();
        if (self.userPaused) self.clear(); else self.schedule();
      });
    }
    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        self.go(parseInt(dot.value, 10) || 0, true);
      });
    });

    if (this.pauseHover && this.autoplayMs) {
      this.host.addEventListener('mouseenter', function () { self.hovering = true; self.setPlayVar(); self.clear(); });
      this.host.addEventListener('mouseleave', function () { self.hovering = false; self.setPlayVar(); self.schedule(); });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { self.clear(); } else { self.schedule(); }
      self.setPlayVar();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        self.inView = entries[0].isIntersecting;
        self.setPlayVar();
        if (self.inView) { self.schedule(); } else { self.clear(); }
      }, { threshold: 0.1 }).observe(this.host);
    }

    /* Dokunmatik / fare kaydirma */
    var startX = null, startY = null;
    this.host.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button, .dkzs-controls')) return;
      startX = e.clientX; startY = e.clientY;
    });
    this.host.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      startX = startY = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) { self.go(self.index + 1, true); } else { self.go(self.index - 1, true); }
      }
    });

    window.addEventListener('keydown', function (e) {
      if (!self.host.contains(document.activeElement)) return;
      if (e.key === 'ArrowRight') { self.go(self.index + 1, true); }
      if (e.key === 'ArrowLeft') { self.go(self.index - 1, true); }
    });
  };

  DkzsController.prototype.setPlayVar = function () {
    var paused = this.userPaused || this.hovering || document.hidden || !this.inView;
    this.host.style.setProperty('--dkzs-play', paused ? 'paused' : 'running');
  };

  DkzsController.prototype.clear = function () {
    if (this.timer) { clearTimeout(this.timer); this.timer = null; }
  };

  DkzsController.prototype.schedule = function () {
    var self = this;
    this.clear();
    if (!this.autoplayMs || this.userPaused || this.hovering || document.hidden || !this.inView) return;
    this.timer = setTimeout(function () { self.go(self.index + 1, false); }, this.autoplayMs);
  };

  DkzsController.prototype.go = function (i, byUser) {
    var count = this.slides.length;
    if (count < 2) return;
    var next = ((i % count) + count) % count;
    if (next === this.index) { if (!byUser) this.schedule(); return; }
    var self = this;

    this.slides[this.index].classList.remove('is-active', 'dkzs-animate');
    this.slides[this.index].setAttribute('aria-hidden', 'true');
    this.index = next;
    var active = this.slides[next];
    active.classList.add('is-active');
    if (!REDUCED) active.classList.add('dkzs-animate');
    active.removeAttribute('aria-hidden');

    if (this.mode === 'slide' && this.track) {
      this.track.style.transform = 'translateX(-' + (next * 100) + '%)';
    }

    this.dots.forEach(function (dot, di) {
      dot.setAttribute('aria-current', di === self.index ? 'true' : 'false');
    });

    this.applyFocusability();
    this.restartProgress();
    this.restartFp();
    this.schedule();
  };

  /* Aktif olmayan slaytlardaki linkler klavye odagindan cikarilir */
  DkzsController.prototype.applyFocusability = function () {
    var self = this;
    this.slides.forEach(function (slide, si) {
      var focusables = slide.querySelectorAll('a, button');
      Array.prototype.forEach.call(focusables, function (el) {
        if (el.classList.contains('dkzs-slide__link') || el.classList.contains('dkzs-fp__media')) return;
        if (si === self.index) { el.removeAttribute('tabindex'); }
        else { el.setAttribute('tabindex', '-1'); }
      });
    });
  };

  /* Durdur/oynat halkasindaki ilerlemeyi bastan baslat */
  DkzsController.prototype.restartProgress = function () {
    var paths = this.host.querySelectorAll('.dkzs-playpause .dkzs-progress__path');
    Array.prototype.forEach.call(paths, function (p) {
      p.style.animation = 'none';
      void p.getBoundingClientRect();
      p.style.animation = '';
    });
  };

  /* One cikan urun kartindaki varyant mini-donguleri */
  DkzsController.prototype.startFp = function () {
    var self = this;
    if (!this.fpSliders) {
      this.fpSliders = Array.prototype.slice.call(this.host.querySelectorAll('[data-dkzs-fp]'));
    }
    if (!this.fpSliders.length || REDUCED) return;
    if (this.fpTimer) clearInterval(this.fpTimer);
    this.fpTimer = setInterval(function () {
      if (document.hidden || !self.inView || self.userPaused || self.hovering) return;
      self.fpSliders.forEach(function (fp) {
        var slide = fp.closest('.dkzs-slide');
        if (slide && !slide.classList.contains('is-active')) return;
        var items = fp.querySelectorAll('.dkzs-fp__item');
        if (items.length < 2) return;
        var current = fp.querySelector('.dkzs-fp__item.is-active') || items[0];
        var idx = Array.prototype.indexOf.call(items, current);
        current.classList.remove('is-active');
        items[(idx + 1) % items.length].classList.add('is-active');
      });
    }, FP_INTERVAL);
  };

  /* Slayt degisince aktif slayttaki mini-dongu ilk varyanta doner ve sayac sifirlanir */
  DkzsController.prototype.restartFp = function () {
    var active = this.slides[this.index];
    if (!active) return;
    var fp = active.querySelector('[data-dkzs-fp]');
    if (!fp) return;
    var items = fp.querySelectorAll('.dkzs-fp__item');
    if (items.length < 2) return;
    Array.prototype.forEach.call(items, function (el, i) {
      el.classList.toggle('is-active', i === 0);
    });
    this.startFp();
  };

  if ('customElements' in window && !customElements.get('dkzs-slideshow')) {
    customElements.define('dkzs-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.dkzsInit) return;
        this.dkzsInit = true;
        var self = this;
        requestAnimationFrame(function () { new DkzsController(self); });
      }
    });
  } else if (!('customElements' in window)) {
    document.addEventListener('DOMContentLoaded', function () {
      Array.prototype.forEach.call(document.querySelectorAll('dkzs-slideshow'), function (el) {
        new DkzsController(el);
      });
    });
  }
})();
